import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Card, Container, Form, Button, Row, Col } from "react-bootstrap";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import { getQueryString } from "../../../utils/Query";
import TableForm2s from "../../../components/TableFormScrb";
import SearchFilter from "../../../components/SearchFilter";
import ConfirmModal from "../../../components/ConfirmModal";
import { addEditServiceRequest, getServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";
import { useNavigate, useLocation } from "react-router-dom";
import InputSearch from "../../../components/InputSearhComponent";
import TechItemReturnService from "../../../services/techitemreturn";
import { formatDate } from "../../../commons/FormatValue";

export default function EditReturnEquipment() {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [JobType, setJobType] = useState([]);
  const [SeqNo, setSeqNo] = useState([]);
  const [loading, setLoading] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [querySearch, setQuerySearch] = useState(false);
  const { state } = useLocation();
  const [allWorkNo, setAllWorkNo] = useState()

  useEffect(() => {
    // fetchSeqNo()
    getData()
    setJobType(state.JobType)
  }, [])

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData?.team,
      disabled: true,
      size: 3
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData?.tech_name,
      disabled: true,
      size: 3
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 3,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: SeqNo
      }),
      required: true,
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechItemReturnService.getSeqNoTechItemReturn(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seq_no
            }))
            setSeqNo(newArray)
          }
        });
      }
    },
  ];

  const columns = [
    {
      name: "RepDate",
      label: "วันที่ตรวจรับ",
      readOnly: true
    },
    {
      name: "RepNo",
      label: "เลขที่ตรวจรับ",
      readOnly: true
    },
    {
      name: "EquipmentCode",
      label: "รหัสอุปกรณ์/อะไหล่",
      width: "200px",
      readOnly: true
    },
    {
      name: "EquipmentName",
      label: "ชื่ออุปกรณ์/อะไหล่",
      showTooltip: true,
      width: "200px",
      readOnly: true
    },
    {
      name: "ModelNumber",
      label: "Model Number",
      width: "180px",
      readOnly: true
    },
    {
      name: "RequireQuantity",
      label: "เบิก",
      width: "80px",
      readOnly: true
    },
    {
      name: "ReceivedQuantity",
      label: "รับ",
      width: "80px",
      readOnly: true
    },
    {
      name: "ReturnQuantity",
      label: "คืน",
      width: "80px",
      type: "number",
      min: 0
    },
    {
      name: "Unit",
      label: "หน่วย",
      readOnly: true
    },
  ];

  function getData(search) {
    if (!search) return
    const page = search?.page || 1
    const limit = search?.limit || 100
    const q = getQueryString({ page: page, limit: limit, ...search })
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechItemReturnService.getTechItemReturnBySeq(q),
      callback: (res) => { initData(res.data) }
    });
  }
  function initData(data) {
    const newArray = data[0]?.BillOfReqHd.BillOfReqDt?.map((items) => ({
      ...items,
      RepDate: formatDate(data[0].TechInspRevItem?.tech_insp_rev_date),
      RepNo: data[0].TechInspRevItem?.tech_insp_rev_no,
      EquipmentCode: items.Item.Item_Code,
      EquipmentName: items.Item.Item_Name_EN || items.Item.Item_Name_TH,
      ModelNumber: items.Item.Item_Model,
      RequireQuantity: items.Req_Qty,
      ReceivedQuantity: items.Iss_Qty,
      ReturnQuantity: items.TechItemReturn?.item_return_qty,
      Unit: items.Item.Unit,
    }));
    setTableData(newArray || [])
  }

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    try {
      dataCallback?.forEach(async ele => {
        if (ele.TechItemReturn) {
          addEditServiceRequest({
            showAlert,
            setLoading,
            // serviceRequest: TechItemReturnService.editTechItemReturn(ele.Id, {
            serviceRequest: TechItemReturnService.createTechItemReturn({
              array: [{
                "item_return_bill_id": ele.TechItemReturn?.item_return_bill_id,
                "bill_of_dt_id": ele.TechItemReturn?.bill_of_dt_id,
                "item_id": ele.TechItemReturn?.id,
                "item_return_qty": +ele.ReturnQuantity
              }]
            }),
            navigated: (navi) => navigate("/service_work/return_equipment")
          });
        }
      })
    } catch (error) {
      console.error(error);
    }
  };

  const handleValidated = (search, type) => {
    if (type == "submit") {
      if (search?.seq_no) {
        setValidated(false)
        getData(search)
      } else {
        setValidated(true)
      }
    } else if (search?.seq_no) {
      setValidated(false)
    } else {
      setTableData([])
      setValidated(false)
    }
  };

  function fetchSeqNo(search) {
    if (!search) {
      if (!allWorkNo) {
        getSeqNoList({}, 'all')
      } else {
        setWorkNo(allWorkNo)
      }
      return
    }

    getSeqNoList(search)
  }
  function getSeqNoList(search, isAll) {
    const q = getQueryString(search)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechItemReturnService.getSeqNoTechItemReturn(q),
      callback: (res) => {
        const data = res.data?.map(d => {
          return { seq_no: d.seqJob?.seqNo }
        })
        if (isAll) {
          setAllWorkNo(data)
        }
        setSeqNo(data)
      }
    });
  }

  return (
    <>
      <Helmet>
        <title>{"คืนอุปกรณ์/อะไหล่"}</title>
        <meta name="description" content="Return Equipment/Parts Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Title className="mb-4 mt-2 fs-2 text-center">
            แก้ไขข้อมูลอุปกรณ์/อะไหล่
          </Card.Title>

          {/* <SearchFilter
            data={searchInput}
            inputField={searchInput}
            searchCallback={array => {
              // getData({ start: array[2].value || "", end: array[3].value || "" })
            }} */}
          <Form noValidate validated={validated} >
            <InputSearch
              inputField={searchInput}
              field={searchInput}
              searchByField={{ name: 'seq_no', queryService: search => fetchSeqNo(search) }}
              searchCallback={search => { search ? getData(search) : setTableData([]); setQuerySearch() }}
              fieldClassName={{ actionButton: "", inputRow: "justify-content-center" }}
            />
          </Form>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดแก้ไขข้อมูลอุปกรณ์/อะไหล่
            </Card.Title>
          </Card.Header>

          <Form noValidate >
            <TableForm2s
              data={tableData}
              columns={columns}
              pending={loading}
              pagination={false}
              onChangeCallback={newData => {
                setTableData(newData)
              }}
            />
          </Form>

          <Row className="justify-content-end mt-4">
            <Col className="col-auto">
              <Button
                type="submit"
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
                onClick={() => tableData.length && setShowModal(!showModal)}
              >
                บันทึกข้อมูล
              </Button>
              <ConfirmModal
                show={showModal}
                data={tableData}
                content={"save"}
                onSubmitCallback={handleSubmit}
              />
              <Button
                variant="outline-secondary"
                className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                onClick={() =>
                  navigate("/service_work/return_equipment")
                }
              >
                ย้อนกลับ
              </Button>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
}
